export { CRMActivityDefintionDataService } from './crm-activity-definition-data.service'
export { CRMActivityDefinitionConnector } from './crm-activity-definition.connector'